import { useState } from "react";
import { toast } from "sonner";
import { errMsg, formatDate, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { canWrite } from "./helpers";

const REASONS = { opposizione: "Opposizione", disiscrizione: "Disiscrizione", non_contattare: "Chiede di non essere contattato" };

// «Do not contact»: automatic emails (also service ones) are skipped for this contact's addresses.
export function ContactPreference({ tid, c, role, onSaved }) {
  const api = useApi();
  const on = !!c.do_not_contact?.on;
  const [reason, setReason] = useState("non_contattare");
  const [busy, setBusy] = useState(false);
  const save = async (v) => {
    setBusy(true);
    try { await api.post(`/t/${tid}/crm/contacts/${c.id}/contact-preference`, { do_not_contact: v, reason: v ? reason : null }); toast.success(v ? "Contatto escluso dalle email automatiche" : "Email automatiche di nuovo consentite"); onSaved(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className={`mt-2 rounded-md border px-2.5 py-2 text-xs ${on ? "border-red-200 bg-red-50 text-red-900" : "border-slate-200 text-slate-600"}`} data-testid="contact-preference">
      {on ? <p data-testid="contact-dnc-state"><b>Non contattare</b> · {REASONS[c.do_not_contact.reason]} · dal {formatDate(c.do_not_contact.at, true)}{c.do_not_contact.by ? ` (${c.do_not_contact.by})` : ""}. Nessuna email automatica verrà preparata.</p>
        : <p data-testid="contact-dnc-state">Email automatiche di servizio consentite (conferme e promemoria).</p>}
      {canWrite(role) && <div className="mt-1.5 flex flex-wrap items-center gap-2">
        {!on && <><span className="text-slate-500">Motivo</span><Select value={reason} onValueChange={setReason}><SelectTrigger className="h-10 w-full text-xs sm:w-64" aria-label="Motivo" data-testid="contact-dnc-reason"><SelectValue /></SelectTrigger>
          <SelectContent>{Object.entries(REASONS).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent></Select></>}
        <Button size="sm" variant="outline" className="h-10" disabled={busy} onClick={() => save(!on)} data-testid="contact-dnc-toggle">{on ? "Consenti di nuovo" : "Segna «non contattare»"}</Button>
      </div>}
    </div>);
}
